import React, { useState } from "react";

const GenerateBirthdayFlyer = () => {
  const [name, setName] = useState("");
  const [photo, setPhoto] = useState(null);
  const [flyerUrl, setFlyerUrl] = useState(null);

  const handleGenerate = async () => {
    const formData = new FormData();
    formData.append("photo", photo);

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/generate-flyer?name=${name}`,
      {
        method: "POST",
        body: formData,
      }
    );

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    setFlyerUrl(url);
  };

  return (
    <div>
      <input
        type="text"
        onChange={(e) => setName(e.target.value)}
        placeholder="Client Name"
      />
      <input type="file" onChange={(e) => setPhoto(e.target.files[0])} />
      <button onClick={handleGenerate}>Generate Flyer</button>
      {flyerUrl && (
        <div>
          <img src={flyerUrl} alt="Generated Flyer" />
          <a href={flyerUrl} download="birthday_flyer.png">
            Download Flyer
          </a>
        </div>
      )}
    </div>
  );
};

export default GenerateBirthdayFlyer;
